/** Display formatting. Money is always integer pence (GBP); we never use floats (see primitives). */

import { currencyFormat } from './locale.js';

// Locale + currency live in one place (./locale.ts); these formatters read them
// so a future multi-currency change edits the constant, not every call-site.
const GBP = currencyFormat();
const GBP0 = currencyFormat({ maximumFractionDigits: 0 });

/** 14000 → "£140.00". */
export function money(pence: number): string {
  return GBP.format(pence / 100);
}

/** 168400 → "£1,684" (whole pounds; used for headline takings). */
export function moneyWhole(pence: number): string {
  return GBP0.format(Math.round(pence / 100));
}

/** 2000 → "20%", 1750 → "17.5%" (commission rates are basis points; display only). */
export function percentFromBps(bps: number): string {
  const pct = bps / 100;
  return `${Number.isInteger(pct) ? pct : pct.toFixed(1)}%`;
}

/** "Amara K." → "AK"; "Walk-in" → "W"; single token → first two letters. */
export function initials(name: string): string {
  const tokens = name.trim().split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return '?';
  if (tokens.length === 1) return tokens[0]!.slice(0, 2).toUpperCase();
  return (tokens[0]![0]! + tokens[tokens.length - 1]![0]!).toUpperCase();
}

export function fullName(firstName: string, lastName?: string | null): string {
  return [firstName, lastName].filter(Boolean).join(' ');
}

/** "+447700900123" → "+44 ••• ••• 123" (light masking for at-a-glance display). */
export function maskPhone(phone: string | null): string {
  if (!phone) return '—';
  const tail = phone.slice(-3);
  return `${phone.slice(0, 3)} ••• ••• ${tail}`;
}

export function pluralize(n: number, one: string, many = `${one}s`): string {
  return `${n} ${n === 1 ? one : many}`;
}
